'use strict';

class GameLoop {
  constructor(canvas) {
    this.canvas = canvas;
    this.running = false;
    this.paused = false;
    this.lastTime = 0;
    this.animationId = null;
    this.updateCallback = null;
    this.renderCallback = null;
    this.tick = this.tick.bind(this);
  }

  requestFrame(callback) {
    if (this.canvas && typeof this.canvas.requestAnimationFrame === 'function') {
      return this.canvas.requestAnimationFrame(callback);
    }
    return requestAnimationFrame(callback);
  }

  cancelFrame(id) {
    if (this.canvas && typeof this.canvas.cancelAnimationFrame === 'function') {
      this.canvas.cancelAnimationFrame(id);
      return;
    }
    if (typeof cancelAnimationFrame === 'function') {
      cancelAnimationFrame(id);
    }
  }

  start(update, render) {
    this.updateCallback = update;
    this.renderCallback = render;
    this.running = true;
    this.paused = false;
    this.lastTime = Date.now();
    this.animationId = this.requestFrame(this.tick);
  }

  tick() {
    if (!this.running) return;
    const now = Date.now();
    const deltaTime = Math.min((now - this.lastTime) / 1000, 0.05);
    this.lastTime = now;
    if (!this.paused && this.updateCallback) {
      this.updateCallback(deltaTime);
    }
    if (this.renderCallback) {
      this.renderCallback();
    }
    this.animationId = this.requestFrame(this.tick);
  }

  pause() {
    this.paused = true;
  }

  resume() {
    this.paused = false;
    this.lastTime = Date.now();
  }

  stop() {
    this.running = false;
    if (this.animationId !== null) {
      this.cancelFrame(this.animationId);
      this.animationId = null;
    }
  }
}

module.exports = GameLoop;
